import { type ImageToken } from '@1debit/chime-assets';

import { RemoteImage } from '../../../server/RemoteImage/RemoteImage';
import { type ImageAssetData, ServerDrivenImage } from '../../../server/ServerDrivenImage/ServerDrivenImage';
import { getImageByToken } from '../../../server/utils/assets';
import { type SmallBannerImagePosition } from '../SmallBanner';

const CENTER_LEFT_IMAGE_SIZE = { width: 96, height: 96 };
const BOTTOM_RIGHT_IMAGE_SIZE = { width: 120, height: 68 };

type BannerImageProps = {
	imageAsset?: ImageAssetData | ImageToken;
	imageUrl?: string;
	imagePosition: SmallBannerImagePosition;
	alt?: string;
};

export const BannerImage = ({ imageAsset, imageUrl, imagePosition, alt }: BannerImageProps) => {
	const defaultSize = imagePosition === 'bottomRight' ? BOTTOM_RIGHT_IMAGE_SIZE : CENTER_LEFT_IMAGE_SIZE;

	function getImageSize() {
		if (imageAsset && typeof imageAsset === 'string') {
			const image = getImageByToken(imageAsset);

			if (image) {
				return { width: image.width, height: image.height };
			} else return defaultSize;
		} else if (imageAsset) {
			return { height: imageAsset.height, width: imageAsset.width };
		} else return defaultSize;
	}

	const { width, height } = getImageSize();

	const renderSize = {
		...(imagePosition === 'bottomRight' ? { height: Math.min(BOTTOM_RIGHT_IMAGE_SIZE.height, height) } : {}),
		...(imagePosition === 'centerLeft' ? { width: Math.min(CENTER_LEFT_IMAGE_SIZE.width, width) } : {}),
	};

	return imageAsset ? (
		typeof imageAsset === 'string' ? (
			<RemoteImage token={imageAsset} alt={alt ? alt : 'Banner image'} {...renderSize} />
		) : (
			<ServerDrivenImage imageAsset={imageAsset} {...renderSize} />
		)
	) : imageUrl ? (
		<img src={imageUrl} alt={alt ? alt : 'Banner image'} width={width} height={height} />
	) : null;
};
